import { GridCustomCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';
import { parseJSON } from 'date-fns';
import { format } from 'date-fns-tz';
import { ViewModel } from '.';

const PickupCell = (props: GridCustomCellProps) => {
  const data = props.dataItem as ViewModel;
  return (
    <td {...props.tdProps}>
      {data.PickupLocation}<br />
      {format(parseJSON(data.PickupDateTime), 'LL/dd/yyyy HH:mm zzz')}
    </td>
  );
}
export default React.memo(PickupCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);